import { Component } from '@angular/core';

@Component({
    selector: 'logout-page',
    templateUrl: './logout-page.component.html',
    styleUrls: ['./logout-page.component.css'],
    standalone: false
})
export class LogoutPageComponent {

}
